import { MapContainer, TileLayer } from 'react-leaflet';
import { LatLngExpression, LatLngBoundsExpression } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useMapStore } from '../../store/mapStore';
import LocationMarker from './LocationMarker';
import GeographicLabels from './GeographicLabels';
import JourneyPlayback from './JourneyPlayback';

const OdysseyMap = () => {
  const filteredLocations = useMapStore((state) => state.getFilteredLocations());

  // Center of Mediterranean
  const center: LatLngExpression = [38.0, 20.0];

  // Mediterranean bounds with buffer
  // Southwest: Southern Tunisia, West of Gibraltar
  // Northeast: Northern Turkey, Eastern Mediterranean
  const maxBounds: LatLngBoundsExpression = [
    [30.0, -10.0], // Southwest corner (with buffer)
    [46.0, 42.0]   // Northeast corner (with buffer)
  ];

  return (
    <MapContainer
      center={center}
      zoom={6}
      maxBounds={maxBounds}
      maxBoundsViscosity={1.0}
      minZoom={5}
      style={{ height: '100vh', width: '100vw' }}
      className="odyssey-map"
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        className="ancient-map-tiles"
      />

      {/* Journey Playback Component */}
      <JourneyPlayback />

      {/* Geographic Labels */}
      <GeographicLabels />

      {/* Location Markers */}
      {filteredLocations.map((location) => (
        <LocationMarker key={location.id} location={location} />
      ))}
    </MapContainer>
  );
};

export default OdysseyMap;
